import { createContext } from 'react';
import { Accordion as AccordionWrapper } from 'react-accessible-accordion';

import styles from './Accordion.module.scss';

export const InViewContext = createContext({
  inView: false
});

type Props = {
  allowMultipleExpanded?: boolean;
  allowZeroExpanded?: boolean;
  children: React.ReactNode;
};

const Accordion: React.FC<Props> = ({
  children,
  allowMultipleExpanded = false,
  allowZeroExpanded = false
}) => {
  const firstAccordionItem = children && children[0];
  return (
    <AccordionWrapper
      className={styles.accordionWrapper}
      preExpanded={[firstAccordionItem?.key]}
      allowMultipleExpanded={allowMultipleExpanded}
      allowZeroExpanded={allowZeroExpanded}
    >
      {children}
    </AccordionWrapper>
  );
};
export default Accordion;
